/* @ngInject */
const orderPosition = (utils) => {
  return (items, field) => {
    var filtered = []
    utils.forEach(items, (item) => {
      filtered.push(item)
    })
    filtered.sort((a, b) => {
      return (CustomOrder(a.position) > CustomOrder(b.position) ? 1 : -1)
    })
    return filtered
  }
}

const CustomOrder = (item) => {
  if (!item) {
    return null
  }
  const parts = item.split('-')
  const number = +parts[0]
  return number
}

export default orderPosition



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/utils/orderPosition.filter.js